const RF = {

    state: {
        model: "aura",
        option: "onetime",      // onetime | prepay | ppd (pay per delivery)
        prepayType: "6months",  // 3months | 6months
        years: 2,
        ppdMonths: 6            // 3 | 6 | 9 | 12
    },

    // line item property for the date, per purchase option
    DATE_PROPERTY: {
        prepay: "Preferred First Delivery Date",
        ppd: "Preferred First Billing Date"
    },

    datepicker: null,
    adding: false,

    init() {

        if (!document.querySelector(".rf-selector")) return;

        this.initDatepicker();
        this.bindEvents();
        this.refreshSelection();

        // Back / swipe-back (mostly mobile) restores this page from the bfcache with
        // its JS state, so `adding` would still be true from the last add to cart
        window.addEventListener("pageshow", event => {
            if (event.persisted) {
                this.adding = false;
            }
        });

    },

    bindEvents() {

        const self = this;

        // ============================
        // MODEL
        // ============================

        $(document).on("click", ".rf-model", function () {

            $(".rf-model").removeClass("active");
            $(this).addClass("active");

            self.state.model = $(this).data("model");

            self.refreshSelection();

        });

        // ============================
        // PURCHASE OPTION
        // ============================

        $(document).on("click", ".rf-option", function () {

            $(".rf-option").removeClass("active");
            $(this).addClass("active");

            self.state.option = $(this).data("option");

            self.refreshSelection();

        });

        // ============================
        // DELIVERY FREQUENCY
        // ============================

        $(document).on("click", ".rf-prepay-frequency", function () {

            $(".rf-prepay-frequency").removeClass("active");
            $(this).addClass("active");

            self.state.prepayType = $(this).data("type");

            self.refreshSelection();

        });

        $(document).on("click", ".rf-ppd-frequency", function () {

            $(".rf-ppd-frequency").removeClass("active");
            $(this).addClass("active");

            self.state.ppdMonths = Number($(this).data("months"));

            self.refreshSelection();

        });

        // ============================
        // PAYMENT PLAN
        // ============================

        $(document).on("change", ".rf-payment-select", function () {

            self.state.years = Number($(this).find(":selected").data("years"));

            self.refreshSelection();

        });

    },

    initDatepicker() {

        const input = document.getElementById("rf-delivery-date");

        if (!input) return;

        // the allowed dates depend on the model: applyDateRange() in refreshSelection()
        if (typeof flatpickr === "function") {

            this.datepicker = flatpickr(input, {
                dateFormat: "d/m/Y",
                disableMobile: true,
                onChange: () => this.toggleDateError(false)
            });

        } else {

            // flatpickr failed to load: fall back to the browser's date picker
            input.type = "date";
            input.readOnly = false;
            input.addEventListener("change", () => this.toggleDateError(false));

        }

    },

    // First delivery from the model's filter lead time (custom_fields.lead_time on the
    // one-time filter), or tomorrow if that has passed or isn't set; up to 365 days after
    dateRange() {

        const minDate = new Date();
        minDate.setHours(0, 0, 0, 0);
        minDate.setDate(minDate.getDate() + 1);

        const [year, month, day] = (this.oneTimeItem().dataset.leadTime || "").split("-").map(Number);
        const leadTime = year ? new Date(year, month - 1, day) : null;

        if (leadTime && leadTime > minDate) {
            minDate.setTime(leadTime.getTime());
        }

        const maxDate = new Date(minDate);
        maxDate.setDate(maxDate.getDate() + 365);

        return { minDate, maxDate };

    },

    // set the date picker to the current model's range, clearing a date outside it
    applyDateRange() {

        const { minDate, maxDate } = this.dateRange();

        if (this.datepicker) {

            this.datepicker.set("minDate", minDate);
            this.datepicker.set("maxDate", maxDate);

            const date = this.datepicker.selectedDates[0];

            if (date && (date < minDate || date > maxDate)) {
                this.datepicker.clear();
            }

            return;

        }

        const input = document.getElementById("rf-delivery-date");

        if (!input) return;

        // native date input works in yyyy-mm-dd (local date, not UTC)
        const toISO = date => [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0")
        ].join("-");

        input.min = toISO(minDate);
        input.max = toISO(maxDate);

        if (input.value && (input.value < input.min || input.value > input.max)) {
            input.value = "";
        }

    },

    // ==========================================
    // MASTER LIST LOOKUPS
    // ==========================================

    oneTimeItem() {

        return document.querySelector(
            `.rf-master-item[data-model="${this.state.model}"][data-type="onetime"]`
        );

    },

    prepayItems() {

        return [...document.querySelectorAll(
            `.rf-master-item[data-model="${this.state.model}"][data-type="${this.state.prepayType}"]`
        )].sort((a, b) => a.dataset.years - b.dataset.years);

    },

    // falls back to the shortest plan if this model has no plan for the chosen years
    prepayItem() {

        const items = this.prepayItems();

        return items.find(el => Number(el.dataset.years) === this.state.years) || items[0];

    },

    // Seal pay-per-delivery plan (rendered by filter-ppd-plans); null until the
    // model's subscription product is set up
    ppdPlan() {

        return document.querySelector(
            `.ppd-plan[data-model="${this.state.model}"][data-months="${this.state.ppdMonths}"]`
        );

    },

    // price per filter set in cents (prepay variants cover `frequency` deliveries)
    perSetPrice(item) {

        const frequency = Number(item.dataset.frequency) || 1;

        return Math.round(Number(item.dataset.price) / frequency);

    },

    formatMoney(cents) {

        return theme.Currency.formatMoney(cents).replace(".00", "");

    },

    refreshSelection() {

        const option = this.state.option;

        // ==========================================
        // SHOW GROUPS FOR THE PURCHASE OPTION
        // ==========================================

        document.querySelectorAll(".rf-selector [data-rf-show]").forEach(el => {
            el.classList.toggle("hide", !el.dataset.rfShow.split(" ").includes(option));
        });

        const oneTime = this.oneTimeItem();
        const prepay = this.prepayItem();

        if (prepay) {
            this.state.years = Number(prepay.dataset.years);
        }

        // first delivery date range follows the model's filter lead time
        this.applyDateRange();

        // pay per delivery: only offer the frequencies the model's Seal product has
        const ppdPlans = [...document.querySelectorAll(`.ppd-plan[data-model="${this.state.model}"]`)];
        const ppdMonths = ppdPlans.map(el => Number(el.dataset.months));

        if (ppdPlans.length && !ppdMonths.includes(this.state.ppdMonths)) {
            this.state.ppdMonths = ppdMonths[0];
        }

        $(".rf-ppd-frequency").each((i, el) => {
            const months = Number($(el).data("months"));
            $(el).toggleClass("hide", ppdPlans.length > 0 && !ppdMonths.includes(months));
            $(el).toggleClass("active", months === this.state.ppdMonths);
        });

        const ppd = this.ppdPlan();

        // ==========================================
        // CARD PRICES
        // ==========================================

        const oneTimePrice = this.formatMoney(this.perSetPrice(oneTime));

        $('.rf-option-price[data-option="onetime"]').text(`${oneTimePrice}/set`);

        $('.rf-option-price[data-option="prepay"]').html(
            prepay ? `${this.formatMoney(this.perSetPrice(prepay))}/set, <span class="rf-nowrap">pay once</span>` : ""
        );

        // the Seal plan's price, or the one-time price until the model has a Seal product
        const ppdPrice = ppd ? Number(ppd.dataset.price) : this.perSetPrice(oneTime);

        $('.rf-option-price[data-option="ppd"]').text(`${this.formatMoney(ppdPrice)}/set`);

        $(".rf-ppd-months").text(this.state.ppdMonths);

        // ==========================================
        // PAYMENT PLAN
        // ==========================================

        const select = $(".rf-payment-select");

        select.empty();

        this.prepayItems().forEach(masterItem => {

            const years = Number(masterItem.dataset.years);

            select.append(`
                <option
                    value="${masterItem.dataset.variant}"
                    data-years="${years}"
                    ${masterItem === prepay ? "selected" : ""}
                >
                    ${years} ${years > 1 ? "years" : "year"} upfront${years > 1 ? ` (${years} years warranty)` : ""}
                </option>
            `);

        });

        const MODEL_LABELS = {
            aura: "Aura",
            vortex: "Vortex",
            vortexpro: "Vortex Pro"
        };
        const subtitle = document.querySelector(".product-single__title .subtitle");

        if (subtitle) {
            subtitle.textContent =
                MODEL_LABELS[this.state.model];
        }

        // ==========================================
        // UPDATE CURRENT SELECTION
        // ==========================================

        // pay per delivery shows the one-time filter (gallery, stock); the Seal
        // variant + selling plan are swapped in at add to cart
        const item = option === "prepay" ? prepay : oneTime;
        const price = option === "ppd" ? ppdPrice : this.perSetPrice(item);

        const current = document.getElementById("currentSelection");

        current.dataset.variant  = item.dataset.variant;
        current.dataset.price    = (price / 100).toFixed(2);
        current.dataset.compare  = item.dataset.compare || "";
        current.dataset.handle   = item.dataset.handle || "";
        current.dataset.image    = item.dataset.image || "";
        current.dataset.stocknum = item.dataset.stocknum || 0;
        current.dataset.restock  = item.dataset.restock || "";

        $(".product-single__thumbnails-items").removeClass(" active");
        $(".product-single__thumbnails-items." + current.dataset.handle).addClass(" active");
        $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
        $(".product-single__thumbnails-items." + current.dataset.handle + " a").addClass(
            "active-thumb",
        );

        // refresh theme
        if (typeof updateLinks === "function") {
            updateLinks();
        }

        if (typeof updatePrice === "function") {
            updatePrice();
        }
        if (typeof updateInstallment === "function") {
            updateInstallment();
        }
        if (typeof updateThumbnail === "function") {
            updateThumbnail();
        }
        if (typeof updateStockIndicator === "function") {
            updateStockIndicator();
        }

    },

    // ==========================================
    // ADD TO CART (called from bundles.js)
    // ==========================================

    // Prepay and pay per delivery carry the delivery date as a line item
    // property, so the plain cart links built by updateLinks() can't be used.
    handlesCart() {

        return this.state.option !== "onetime" && !!document.querySelector(".rf-selector");

    },

    // saved on the order as yyyy-mm-dd, e.g. "2026-11-21"
    deliveryDate() {

        if (this.datepicker) {
            const date = this.datepicker.selectedDates[0];
            return date ? this.datepicker.formatDate(date, "Y-m-d") : "";
        }

        // native date input value is already yyyy-mm-dd
        return $("#rf-delivery-date").val() || "";

    },

    toggleDateError(show) {

        $(".rf-date-error").toggleClass("hide", !show);
        $("#rf-delivery-date").toggleClass("rf-invalid", show);

    },

    async addToCart(destination) {

        if (this.adding) return;

        const date = this.deliveryDate();

        if (!date) {
            this.toggleDateError(true);
            document.getElementById("rf-delivery-date").scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        const quantity = parseInt($("#currentSelection").attr("data-quantity"), 10) || 1;

        const item = {
            id: Number($("#currentSelection").attr("data-variant")),
            quantity: quantity,
            properties: { [this.DATE_PROPERTY[this.state.option]]: date }
        };

        // pay per delivery: the model's Seal subscription variant + selling plan
        // (models without one yet fall back to the one-time filter)
        const ppd = this.state.option === "ppd" ? this.ppdPlan() : null;

        if (ppd) {
            item.id = Number(ppd.dataset.variant);
            item.selling_plan = Number(ppd.dataset.sellingPlan);
        }

        const items = [item];

        this.adding = true;

        try {

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: items })
            });

            if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                throw new Error(error.description || `HTTP ${response.status}`);
            }

            location.href = destination;

        } catch (error) {

            console.error("Failed to add filter to cart:", error);
            alert("Sorry, we couldn't add this to your cart. " + error.message);
            this.adding = false;

        }

    }

};

$(function () {

    RF.init();

});
